import { collection, doc } from 'firebase/firestore'
import { getEffectiveServices } from './firebaseServiceContext'

export default () =>
  doc(collection(getEffectiveServices().firestore, 'a')).id
